import React from 'react';

interface LogoProps {
    className?: string;
}

export const Logo: React.FC<LogoProps> = ({ className = 'h-8' }) => {
    return (
        <div className="flex items-center">
            {/* Light theme logo */}
            <img
                src="/logos/vsl-logo-light.png"
                alt="VSL Logo"
                className={`${className} w-auto dark:hidden`}
            />
            {/* Dark theme logo */}
            <img
                src="/logos/vsl-logo-dark.png"
                alt="VSL Logo"
                className={`${className} w-auto hidden dark:block`}
            />
        </div>
    );
};
